import React, {useEffect} from 'react';
import { Box, Icon, IconButton, Icons, Scroll, Text, toRem } from 'folds';
import { useAtomValue } from 'jotai';
import { RoomCard } from '../../components/room-card';
import { RoomTopicViewer } from '../../components/room-topic-viewer';
import { Page, PageHeader, PageHero, PageHeroSection  } from '../../components/page';
import { RoomSummaryLoader } from '../../components/RoomSummaryLoader';
import { useRoomNavigate } from '../../hooks/useRoomNavigate';
import { useMatrixClient } from '../../hooks/useMatrixClient';
import { allRoomsAtom } from '../../state/room-list/roomList';
import { ScreenSize, useScreenSizeContext } from '../../hooks/useScreenSize';
import { BackRouteHandler } from '../../components/BackRouteHandler';

import buildConfig from '../../../../build.config';

import InfoDocLogo from '../../../../public/icon/CurveLogo.png';

type JoinBeforeNavigateProps = { roomIdOrAlias: string; eventId?: string; viaServers?: string[] };
export function JoinBeforeNavigate({
  roomIdOrAlias,
  eventId,
  viaServers,
}: JoinBeforeNavigateProps) {
  const mx = useMatrixClient();
  const allRooms = useAtomValue(allRoomsAtom);
  const { navigateRoom, navigateSpace } = useRoomNavigate();
  const screenSize = useScreenSizeContext();

  const handleView = (roomId: string) => {
    if (mx.getRoom(roomId)?.isSpaceRoom()) {
      navigateSpace(roomId);
      return;
    }
    navigateRoom(roomId, eventId);
  };

  useEffect(() => {
    if (buildConfig.enableWidgetMode) {
      // 加上 reload 限制，避免無限循環
      const hasReloaded = sessionStorage.getItem("roomLeftReloaded");
      if (!hasReloaded) {
        sessionStorage.setItem("roomLeftReloaded", "true");
        setTimeout(() => {
        window.parent.postMessage({ type: "reload-request" }, "*"); // window.top?.location.reload();
        }, 1000); // 延遲 1 秒 reload，避免過快閃爍
      } 

      // for auto login can reset when logined 
      sessionStorage.removeItem("hasRedirectedToSSO");
    }

  }, []);

  return (
    <Page>
      <PageHeader balance>
        <Box grow="Yes" gap="200">Room left.
          { /*
          <Box shrink="No">
            {screenSize === ScreenSize.Mobile && (
              <BackRouteHandler>
                {(onBack) => (
                  <IconButton onClick={onBack}>
                    <Icon src={Icons.ArrowLeft} />
                  </IconButton>
                )}
              </BackRouteHandler>
            )}
          </Box>
          <Box grow="Yes" justifyContent="Center" alignItems="Center" gap="200">
            <Text size="H3" truncate>
              {roomIdOrAlias}
            </Text>
          </Box>
          */ }
        </Box>
      </PageHeader>
      <Box grow="Yes">
        <PageHeroSection>
          <PageHero
            icon={<img width="70" height="70" src={InfoDocLogo} alt="InfoDoc Logo" />}
            title="Curve"
            subTitle={<span>InfoDoc Technology Corporation</span>}
          >
            {buildConfig.enableWidgetMode && (<Box justifyContent="Center">
              <span>重新整理中...</span>
            </Box>)}
          </PageHero>
        </PageHeroSection>
        { /*
        <Scroll hideTrack visibility="Hover" size="0">
          <Box style={{ height: '100%' }} grow="Yes" alignItems="Center" justifyContent="Center">
            <RoomSummaryLoader roomIdOrAlias={roomIdOrAlias}>
              {(summary) => (
                <RoomCard
                  style={{ maxWidth: toRem(364), width: '100%' }}
                  roomIdOrAlias={roomIdOrAlias}
                  allRooms={allRooms}
                  avatarUrl={summary?.avatar_url}
                  name={summary?.name}
                  topic={summary?.topic}
                  memberCount={summary?.num_joined_members}
                  roomType={summary?.room_type}
                  viaServers={viaServers}
                  renderTopicViewer={(name, topic, requestClose) => (
                    <RoomTopicViewer name={name} topic={topic} requestClose={requestClose} />
                  )}
                  onView={handleView}
                />
              )}
            </RoomSummaryLoader>
          </Box>
        </Scroll> */ }
      </Box>
    </Page>
  );
}
